import { render, staticRenderFns } from "./PoliticianImage.vue?vue&type=template&id=7896d7bb&scoped=true"
import script from "./PoliticianImage.vue?vue&type=script&lang=js"
export * from "./PoliticianImage.vue?vue&type=script&lang=js"
import style0 from "./PoliticianImage.vue?vue&type=style&index=0&id=7896d7bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896d7bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
